import Spinner from '../Spinner';
import classes from './Button.module.scss';
import clsx from 'clsx';

interface ButtonProps {
  text: string;
  className?: any;
  onClick: () => void;
  loading?: boolean;
  invert?: boolean;
  disabled?: boolean;
}

// `${props.invert ? classes.invertedButton : classes.button} ${props.className}`

export default function Button(props: ButtonProps) {
  return (
    <button
      className={clsx(classes.button, props.className, { [classes.invertedButton]: props.invert })}
      style={{width:"max-content"}}
      onClick={props.onClick}
      disabled={props.loading || props.disabled}>
      {props.loading && <Spinner />}
      {props.text}
    </button>
  );
}
